import { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import RequestorDashboard from "../components/Dashboard/RequestorDashboard";

const MyRequestListPage = () => {
    return (
        <>
            <PageTitle title="OPS | My Request List Page" />
            <MainLayout>
                
                <RequestorDashboard />

            </MainLayout>
        </>
    )
}

export default MyRequestListPage;